import { elementEvents } from 'library/ts/ui/events/ElementEvent';
import { LogService } from 'library/ts/utilities/logger/LogService';
import * as Type from 'library/ts/utilities/modules/Type';
const logger = LogService.create({ prefixes: ['SmartTag:'] });
export const supportsPassive = () => {
    let supportsPassive = false;
    try {
        const opts = Object.defineProperty({}, 'passive', {
            get: () => {
                supportsPassive = true;
            }
        });
        window.addEventListener('testPassive', null, opts);
        window.removeEventListener('testPassive', null, opts);
    }
    catch (e) {
    }
    return supportsPassive;
};
export const addListenerOnce = (target, type, listener) => {
    target.addEventListener(type, function fn(event) {
        target.removeEventListener(type, fn);
        listener(event);
    });
};
export const addElementEvents = (element, eventHandler) => {
    elementEvents().forEach((event) => {
        if (Type.isElement(element) && Type.isFunction(eventHandler)) {
            element.addEventListener(event, eventHandler, (supportsPassive() ? { passive: true } : false));
        }
    });
};
export const removeElementEvents = (element, eventHandler) => {
    elementEvents().forEach((event) => {
        if (Type.isElement(element) && Type.isFunction(eventHandler)) {
            element.removeEventListener(event, eventHandler);
        }
    });
};
export const getListeners = (baseNodeList = [document, window], nodeList = document.querySelectorAll('*'), app = '') => {
    if (window.getEventListeners === undefined) {
        logger.warn(app, 'Utilities:', 'getListeners:', 'window.getEventListeners does not exist on window object');
        return;
    }
    logger.table(baseNodeList.concat([...nodeList]).map((element) => {
        const evs = window.getEventListeners(element);
        return {
            element: element,
            types: Object.keys(evs).join(', '),
            listeners: evs
        };
    }).filter((item) => item.types));
};
